<template>
  <div class="feedback-modal-overlay" v-show="visible" @click="closeModal">
    <div class="feedback-modal" @click.stop>
      <!-- 模态框头部 -->
      <div class="feedback-header">
        <h3 class="feedback-title">{{ type === 0 ? '题目反馈' : '课程反馈' }}</h3>
        <button class="close-btn" @click="closeModal">×</button>
      </div>

      <!-- 反馈类型 -->
      <div class="feedback-section">
        <h4 class="section-title">反馈类型</h4>
        <div class="feedback-types">
          <button v-for="type in feedbackTypes" :key="type.id" :class="['type-btn', { active: activeTagName === type.label }]" @click="selectType(type)">
            {{ type.label }}
          </button>
        </div>
      </div>

      <!-- 问题描述 -->
      <div class="feedback-section">
        <h4 class="section-title">问题描述</h4>
        <textarea v-model="description" class="description-input" :placeholder="feedbackTip" :maxlength="maxLength" rows="5"></textarea>
        <div class="char-count">{{ description.length }}/{{ maxLength }}</div>
      </div>

      <!-- 图片上传 -->
      <div class="feedback-section">
        <h4 class="section-title">
          图片描述
          <span class="image-count">{{ uploadedImages.length }}/3</span>
        </h4>
        <div class="upload-section">
          <!-- 拖拽上传区域 -->
          <div class="drag-upload-area" :class="{ 'drag-over': isDragOver, 'upload-disabled': uploadedImages.length >= 3 }" @dragover.prevent="handleDragOver" @dragenter.prevent="handleDragEnter" @dragleave.prevent="handleDragLeave" @drop.prevent="handleDrop">
            <!-- 已上传图片预览 -->
            <div class="uploaded-images-grid" v-if="uploadedImages.length > 0">
              <div v-for="(image, index) in uploadedImages" :key="index" class="image-preview-item">
                <img :src="image.url" :alt="image.name" />
                <button class="remove-image-btn" @click="removeImage(index)">×</button>
              </div>
            </div>

            <!-- 空状态提示 -->
            <div class="upload-placeholder" v-else>
              <div class="upload-text-main">粘贴或拖拽至这里上传</div>
            </div>
          </div>

          <!-- 添加本地文件按钮 -->
          <button class="add-local-file-btn" :disabled="uploadedImages.length >= 3" @click="triggerFileUpload">
            <i class="plus-icon">+</i>
            添加本地文件
          </button>

          <input ref="fileInput" type="file" accept="image/jpeg,image/png" multiple style="display: none;" @change="handleFileUpload" />
        </div>
      </div>

      <p class="feedback-tip">单张图片大小不超过3M，只支持JPG和PNG格式的文件，最多可上传3张</p>

      <!-- 底部按钮 -->
      <div class="feedback-footer">
        <button class="cancel-btn" @click="closeModal" :disabled="isSubmitting">取消</button>
        <button class="submit-btn" :disabled="!canSubmit || isSubmitting" @click="submitFeedback">
          {{ isSubmitting ? '提交中...' : '确认' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// 引入请求
import {
  api_feedbackTagSelectListByType,
  api_ojFeedbackCreate,
  api_lessonFeedbackCreate
} from '@/api/javaApi'
// 上传文件
import uploadFileSchool from '@/config/uploadFileSchool1.js'

export default {
  name: 'FeedbackModal',
  props: {
    // 题目id
    id: {
      type: String,
      default: ''
    },
    // 0: 题目反馈，1: 课程反馈
    type: {
      type: Number,
      default: 0,
    },
    // 反馈值
    value: {
      type: Boolean,
      default: false
    },
    // 反馈长度
    maxLength: {
      type: Number,
      default: 15000
    }
  },
  data() {
    return {
      visible: false,
      feedbackTip: '请详细描述您的问题，如：\n1. 课件中，第25页，图片错误\n2. 课件顺序不对\n3. 本课讲义打不开\n4. ...',
      description: '',
      uploadedImages: [],
      isSubmitting: false,
      feedbackTypes: [],
      activeTagName: '',
      isDragOver: false,
      isInitialized: false, // 标记是否已经初始化
    }
  },
  computed: {
    canSubmit() {
      return this.activeTagName && this.description.trim().length > 0
    }
  },
  watch: {
    value(newVal) {
      this.visible = newVal
      if (newVal) {
        if (this.type === 0) {
          this.feedbackTip = '请详细描述问题，必要时粘贴代码，如：\n1. 题目描述、格式有误，见截图\n2. 测试数据有误，第7个测试点，粘贴您的代码\n3. 测试数据需加强，数据太少或暴力都能过了，粘贴您的代码\n4. ...\n\n```cpp\n// 尽可能的粘贴您的代码，方便调试\n```'
        } else {
          this.feedbackTip = '请详细描述您的问题，如：\n1. 课件中，第25页，图片错误\n2. 课件顺序不对\n3. 本课讲义打不开\n4. ...'
        }
        this.resetForm()
      }
    },
    visible(newVal) {
      this.$emit('input', newVal)
    }
  },
  methods: {
    // 获取反馈标签
    async getFeedbackTag() {
      console.log('getFeedbackTag 调用，当前 type:', this.type)
      const res = await api_feedbackTagSelectListByType({ type: this.type })
      res.forEach(item => {
        item.label = item.tagName
        item.value = item.id
      })
      this.feedbackTypes = res
      this.activeTagName = res[0].tagName || '';
      this.isInitialized = true; // 标记已经初始化
    },
    // 选择反馈类型
    selectType(typeItem) {
      this.activeTagName = typeItem.tagName
    },
    methodFeedbackCreate(imgs = []) {
      console.log('imgs', imgs)
      let contentImgUrl = '';
      if (imgs.length > 0) {
        contentImgUrl = imgs.map(item => item.url).join(';')
      }
      console.log('contentImgUrl', contentImgUrl)
      if (this.type === 0) {
        return api_ojFeedbackCreate({
          problemId: this.id,
          tagName: this.activeTagName,
          content: this.description,
          contentImgUrl,
        })
      } else {
        return api_lessonFeedbackCreate({
          cmId: this.id,
          tagName: this.activeTagName,
          content: this.description,
          contentImgUrl,
        })
      }
    },
    // 触发文件上传
    triggerFileUpload() {
      this.$refs.fileInput.click()
    },
    // 验证文件格式和大小
    validateFile(file) {
      // 验证图片数量：最多3张
      if (this.uploadedImages.length >= 3) {
        this.$message && this.$message.error('最多只能上传3张图片');
        return false;
      }

      // 验证文件类型：只允许 JPG 和 PNG
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
      if (!allowedTypes.includes(file.type.toLowerCase())) {
        this.$message && this.$message.error('只支持JPG和PNG格式的图片');
        return false;
      }

      // 验证文件大小：不超过3MB
      const maxSize = 3 * 1024 * 1024; // 3MB
      if (file.size > maxSize) {
        this.$message && this.$message.error('图片大小不能超过3M');
        return false;
      }

      return true;
    },

    // 处理文件上传
    handleFileUpload(event) {
      const files = Array.from(event.target.files)

      // 计算还能上传多少张图片
      const remainingSlots = 3 - this.uploadedImages.length;
      const filesToProcess = files.slice(0, remainingSlots);

      // 如果选择的文件数量超过剩余可上传数量，给出提示
      if (files.length > remainingSlots) {
        this.$message && this.$message.warning(`最多只能上传3张图片，已为您选择前${remainingSlots}张`);
      }

      filesToProcess.forEach(file => {
        // 验证文件格式和大小
        if (!this.validateFile(file)) {
          return;
        }

        if (file.type.startsWith('image/')) {
          const reader = new FileReader()
          reader.onload = (e) => {
            this.uploadedImages.push({
              name: file.name,
              url: e.target.result,
              file: file
            })
          }
          reader.readAsDataURL(file)
        }
      })
      event.target.value = '' // 清空input，允许重复选择同一文件
    },

    // 处理复制粘贴上传图片
    handlePaste(event) {
      const clipboardData = event.clipboardData || window.clipboardData
      if (!clipboardData) return

      const items = Array.from(clipboardData.items)
      let processedCount = 0;

      items.forEach(item => {
        if (item.type.startsWith('image/') && processedCount < (3 - this.uploadedImages.length)) {
          const file = item.getAsFile()
          if (file) {
            // 验证文件格式和大小
            if (!this.validateFile(file)) {
              return;
            }

            const reader = new FileReader()
            reader.onload = (e) => {
              this.uploadedImages.push({
                name: `粘贴图片_${Date.now()}.png`,
                url: e.target.result,
                file: file
              })
            }
            reader.readAsDataURL(file)
            processedCount++;
          }
        }
      })
    },
    // 移除图片
    removeImage(index) {
      this.uploadedImages.splice(index, 1)
    },
    // 关闭模态框
    closeModal() {
      this.visible = false
      //   setTimeout(() => {
      //     this.$emit('close')
      //   }, 50)
      setTimeout(() => {
        this.$destroyFeedback(); // 销毁组件 下次打开可以重新加载 - 这行代码不适用于模板中使用的组件
      }, 50)
    },
    // 重置表单
    resetForm() {
      this.activeTagName = this.feedbackTypes[0] ? this.feedbackTypes[0].tagName : '';
      this.description = ''
      this.uploadedImages = []
      this.isSubmitting = false
    },
    // 提交反馈
    async submitFeedback() {
      if (!this.canSubmit || this.isSubmitting) return

      this.isSubmitting = true

      try {
        let uploadedImageUrls = []

        // 如果有图片需要上传
        if (this.uploadedImages.length > 0) {
          // 准备文件列表，格式化为uploadFileSchool需要的格式
          const fileList = this.uploadedImages.map(img => ({
            raw: img.file,
            name: img.name,
            size: img.file.size
          }))
          console.log('fileList', fileList)
          // 调用上传方法，传入fileList和用户code
          const vuexData = JSON.parse(localStorage.getItem('vuex') || '{}');
          const userInfo = vuexData.user.userInfo
          const userCode = userInfo.code
          for (let i = 0; i < fileList.length; i++) {
            const uploadResult = await uploadFileSchool([fileList[i]], userCode, false)
            console.log('上传结果', uploadResult)
            if (uploadResult && uploadResult.length > 0) {
              uploadResult[0].size = uploadResult[0].length;
              uploadedImageUrls.push(uploadResult[0])
            }
          }
          // fileList.forEach(async item => {
          //   const uploadResult = await uploadFileSchool([item], userCode)
          //   console.log('上传结果', uploadResult)
          //   uploadedImageUrls.push(uploadResult)
          // })
          // 提取上传后的图片URL
          // uploadedImageUrls = uploadResult.map(result => ({
          //   name: result.name,
          //   url: result.url,
          //   size: result.length
          // }))
        }

        const feedbackData = {
          type: this.activeTagName,
          description: this.description.trim(),
          images: uploadedImageUrls, // 使用上传后的图片URL
          timestamp: new Date().toISOString()
        }
        console.log('feedbackData', feedbackData)
        await this.methodFeedbackCreate(uploadedImageUrls).then(() => {
          this.$message.success('提交成功')
        })
        // 触发提交事件
        this.$emit('submit', feedbackData)

        // 关闭模态框
        this.closeModal()

      } catch (error) {
        console.error('提交反馈失败:', error)
        // 这里可以添加错误提示
        this.$message && this.$message.error('提交失败，请重试')
      } finally {
        this.isSubmitting = false
      }
    },
    // 处理拖拽上传
    handleDragOver(event) {
      event.preventDefault();
      this.isDragOver = true;
    },
    handleDragEnter(event) {
      event.preventDefault();
      this.isDragOver = true;
    },
    handleDragLeave(event) {
      event.preventDefault();
      this.isDragOver = false;
    },
    handleDrop(event) {
      event.preventDefault();
      this.isDragOver = false;
      const files = Array.from(event.dataTransfer.files);

      // 计算还能上传多少张图片
      const remainingSlots = 3 - this.uploadedImages.length;
      const filesToProcess = files.slice(0, remainingSlots);

      // 如果拖拽的文件数量超过剩余可上传数量，给出提示
      if (files.length > remainingSlots) {
        this.$message && this.$message.warning(`最多只能上传3张图片，已为您选择前${remainingSlots}张`);
      }

      // 过滤并验证文件
      const validFiles = filesToProcess.filter(file => {
        return this.validateFile(file);
      });

      if (validFiles.length > 0) {
        this.handleFileUpload({ target: { files: validFiles } });
      }
    },
  },
  created() {
    // this.getFeedbackTag() - 移除，现在通过 type watcher 处理
  },
  mounted() {
    // 监听ESC键关闭模态框
    const handleEsc = (e) => {
      if (e.key === 'Escape' && this.visible) {
        this.closeModal()
      }
    }
    document.addEventListener('keydown', handleEsc)

    // 监听粘贴事件上传图片
    const handlePaste = (e) => {
      if (this.visible) {
        this.handlePaste(e)
      }
    }
    document.addEventListener('paste', handlePaste)

    // 在组件销毁时移除事件监听器
    this.$once('hook:beforeDestroy', () => {
      document.removeEventListener('keydown', handleEsc)
      document.removeEventListener('paste', handlePaste)
    })
  }
}
</script>

<style lang="scss" scoped>
// 变量定义
$primary-color: #1890ff;
$border-color: #d9d9d9;
$border-color-light: #d0d0d0;
$text-color: #333;
$text-color-secondary: #666;
$text-color-light: #999;
$background-color: #fafafa;
$background-color-light: #f5f6f8;
$danger-color: #ff4d4f;
$success-color: #52c41a;
$border-radius: 6px;
$border-radius-large: 8px;

.feedback-modal-overlay {
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  overflow-y: auto;
  padding: 50px 0;
}

.feedback-modal {
  background: white;
  border-radius: $border-radius-large;
  width: 480px;
  max-width: 90vw;
  margin: auto;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

.feedback-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px 16px;
  border-bottom: 1px solid #e8e8e8;

  .feedback-title {
    width: 100%;
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: $text-color;
    text-align: center;
  }

  .close-btn {
    background: none;
    border: none;
    font-size: 24px;
    color: $text-color-light;
    cursor: pointer;
    padding: 0;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      color: $text-color-secondary;
    }
  }
}

.feedback-section {
  position: relative;
  padding: 10px 20px;

  .section-title {
    margin: 0 0 12px 0;
    font-size: 16px;
    font-weight: 500;
    color: $text-color;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .image-count {
      font-size: 14px;
      color: $text-color-light;
      background: $background-color-light;
      padding: 2px 8px;
      border-radius: 12px;
      font-weight: normal;
    }
  }
}

.feedback-types {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;

  .type-btn {
    padding: 8px 16px;
    border: 1px solid $border-color;
    border-radius: 20px;
    background: #fff;
    color: $text-color-secondary;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      border-color: $primary-color;
      color: $primary-color;
    }

    &.active {
      border-color: $primary-color;
      color: $primary-color;
    }
  }
}

.description-input {
  width: 100%;
  border: 1px solid $border-color;
  border-radius: $border-radius;
  padding: 12px;
  font-size: 14px;
  line-height: 1.5;
  resize: vertical;
  min-height: 180px;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: $primary-color;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }

  &::placeholder {
    color: #bfbfbf;
  }
}

.char-count {
  position: absolute;
  right: 30px;
  bottom: 25px;
  margin-top: 8px;
  font-size: 12px;
  color: $text-color-light;
  pointer-events: none;
}

.upload-section {
  display: flex;
  flex-direction: column;
  border: 1px solid $border-color-light;
  border-radius: $border-radius-large;

  .drag-upload-area {
    box-sizing: border-box;
    min-height: 120px;
    border: 1px dashed $border-color-light;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    background-color: $background-color-light;
    margin: 15px 15px 0 15px;

    &:hover {
      border-color: $primary-color;
      background-color: #f6f9ff;
    }

    &.drag-over {
      border-color: $primary-color;
      background-color: #f0f8ff;
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
    }

    &.upload-disabled {
      border-color: #d9d9d9;
      background-color: #f5f5f5;
      cursor: not-allowed;
      opacity: 0.7;
    }

    .upload-placeholder {
      text-align: center;
      width: 100%;

      .upload-text-main {
        font-size: 14px;
        color: #999999;
        margin: 0;
      }
    }

    .uploaded-images-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
      gap: 12px;
      width: 100%;
      max-height: 200px;
      padding: 10px;
      overflow-y: auto;

      .image-preview-item {
        position: relative;
        width: 80px;
        height: 80px;
        border: 1px solid #e8e8e8;

        img {
          width: 100%;
          height: 100%;
          border-radius: $border-radius;
          object-fit: cover;
        }

        .remove-image-btn {
          position: absolute;
          top: -6px;
          right: -6px;
          width: 18px;
          height: 18px;
          border-radius: 50%;
          background: $danger-color;
          color: white;
          border: none;
          font-size: 12px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        }
      }
    }
  }

  .add-local-file-btn {
    width: 100%;
    background: #ffffff;
    border: none;
    border-radius: $border-radius;
    font-size: 14px;
    color: $text-color-secondary;
    cursor: pointer;
    padding: 10px 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: all 0.2s;
    align-self: flex-start;

    &:hover:not(:disabled) {
      border-color: $primary-color;
      color: $primary-color;
    }

    &:disabled {
      background: #f5f5f5;
      border-color: $border-color;
      color: #bfbfbf;
      cursor: not-allowed;
    }

    .plus-icon {
      font-style: normal;
      font-size: 16px;
      font-weight: bold;
    }
  }
}

// 隐藏旧的样式
.uploaded-images,
.image-preview,
.remove-image {
  display: none;
}

.feedback-tip {
  margin: 10px 20px;
  text-align: center;
  font-size: 10px;
  color: $text-color-light;
}

.feedback-footer {
  padding: 10px 24px 15px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  border-top: 1px solid #e8e8e8;

  .cancel-btn,
  .submit-btn {
    padding: 6px 18px;
    border-radius: $border-radius;
    font-size: 14px;
    cursor: pointer;
    min-width: 60px;
    transition: all 0.2s;
  }

  .cancel-btn {
    background: #fff;
    border: 1px solid $border-color;
    color: $text-color-secondary;

    &:hover {
      border-color: #40a9ff;
      color: #40a9ff;
    }
  }

  .submit-btn {
    background: $primary-color;
    border: 1px solid $primary-color;
    color: white;

    &:hover:not(:disabled) {
      background: #40a9ff;
      border-color: #40a9ff;
    }

    &:disabled {
      background: #f5f5f5;
      border-color: $border-color;
      color: #bfbfbf;
      cursor: not-allowed;
    }
  }
}
</style>

// 全局样式，确保错误提示显示在模态框之上
<style lang="scss">
// 提高 message 组件的 z-index，确保在反馈模态框之上显示
.el-message {
  z-index: 10000 !important;
}

.el-message--error {
  z-index: 10000 !important;
}
</style> 